export class GetManagementRainfallInputByIdlUseCase{
    constructor(repository){
      this.repository=repository
    }
  
    async execute(ID_SECTOR){
      return await this.repository.getRainfallByIdSector(ID_SECTOR)
    }
  }
  